(function () {
  var dataLayerName = 'analyzelyDataLayer';
  var debugLayerName = 'evolovaDataLayer';
  var recentEvents = {};
  var lastCart = null;
  var pendingVariantSelection = null;

  function getCurrency() {
    return (
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.shopCurrency) ||
      'USD'
    );
  }

  function getDeviceCategory() {
    var width = window.innerWidth || document.documentElement.clientWidth || 0;
    if (width < 750) return 'mobile';
    if (width < 1025) return 'tablet';
    return 'desktop';
  }

  function getPageContext(extra) {
    return Object.assign(
      {
        event_source: 'evolova_theme',
        page_location: window.location.href,
        page_path: window.location.pathname,
        device_category: getDeviceCategory()
      },
      extra || {}
    );
  }

  function sendGtag(eventName, params) {
    var payload = getPageContext(params);
    window[dataLayerName] = window[dataLayerName] || [];
    window[debugLayerName] = window[debugLayerName] || [];
    window[debugLayerName].push(Object.assign({ event: eventName, timestamp: Date.now() }, payload));

    if (typeof window.analyzelyGtag === 'function') {
      window.analyzelyGtag('event', eventName, payload);
    } else if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
    } else {
      window[dataLayerName].push(['event', eventName, payload]);
    }
  }

  function dedupe(key, ttl) {
    var now = Date.now();
    if (recentEvents[key] && now - recentEvents[key] < ttl) return true;
    recentEvents[key] = now;
    return false;
  }

  function centsToAmount(value) {
    var number = Number(value);
    if (!Number.isFinite(number)) return 0;
    return number > 1000 ? number / 100 : number;
  }

  function productHandleFromUrl(url) {
    var match = String(url || window.location.pathname).match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function getDataValue(node, key) {
    var attr = 'data-' + key.replace(/[A-Z]/g, function (letter) {
      return '-' + letter.toLowerCase();
    });
    var current = node instanceof Element ? node : null;

    while (current) {
      if (current.dataset && current.dataset[key]) return current.dataset[key];
      if (current.getAttribute && current.getAttribute(attr)) return current.getAttribute(attr);
      current = current.parentElement;
    }

    return '';
  }

  function findVariant(product, variantId) {
    if (!product || !Array.isArray(product.variants)) return null;
    return product.variants.find(function (variant) {
      return String(variant.id) === String(variantId);
    });
  }

  function getSourceArea(target, form) {
    var node = target || form;
    if (!node) return 'unknown';
    var explicitSourceArea = getDataValue(node, 'sourceArea');
    if (explicitSourceArea) return explicitSourceArea;
    if (node.closest?.('cart-drawer')) return 'cart_drawer';
    if (node.closest?.('.template-cart, .section--main-cart, cart-items-component')) return 'cart_page';
    if (node.closest?.('sticky-atc') || String(node.id || '').indexOf('StickyCart-ProductSubmitButton') === 0) return 'sticky_add_to_cart';
    if (node.closest?.('.main-product-information, product-info, .product-form__buttons')) return 'pdp_main';
    if (node.closest?.('quick-add-modal')) return 'quick_add';
    if (node.closest?.('.evo-collection-card__actions, .card--block-button, .card, .card-product, .product-card, .collection, .template-collection, .template-search')) return 'collection_card';
    return 'unknown';
  }

  function getFormForTarget(target) {
    if (!target) return null;
    if (target.closest?.('form')) return target.closest('form');
    if (target.form instanceof HTMLFormElement) return target.form;
    var formId = target.getAttribute?.('form');
    return formId ? document.getElementById(formId) : null;
  }

  function getFormDataValue(form, name) {
    if (!form) return '';
    try {
      return new FormData(form).get(name) || '';
    } catch (e) {
      var input = form.querySelector('[name="' + name + '"]');
      return input ? input.value : '';
    }
  }

  function getQuantity(form, fallback) {
    var quantity = Number(getFormDataValue(form, 'quantity') || fallback || 1);
    return Math.max(1, Number.isFinite(quantity) ? quantity : 1);
  }

  function getProductMeta(form, variantId, lineItem) {
    var metaProduct = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    var variant = findVariant(metaProduct, variantId || lineItem?.variant_id || lineItem?.id);
    var dataTitle = getDataValue(form, 'productTitle');
    var dataHandle = getDataValue(form, 'productHandle');
    var dataProductId = getDataValue(form, 'productId');
    var title =
      lineItem?.product_title ||
      (metaProduct && metaProduct.title) ||
      dataTitle ||
      (form && form.closest('[data-product-title]') && form.closest('[data-product-title]').dataset.productTitle) ||
      document.querySelector('[data-product-title]')?.textContent ||
      document.querySelector('h1')?.textContent ||
      document.title;
    var productHandle = lineItem?.handle || dataHandle || productHandleFromUrl();
    var normalizedVariantId = String(variantId || lineItem?.variant_id || lineItem?.id || (variant && variant.id) || '');

    return {
      item_id: normalizedVariantId,
      item_name: String(title || '').trim(),
      item_brand: String(lineItem?.vendor || (metaProduct && metaProduct.vendor) || 'Evolova'),
      item_variant: String(lineItem?.variant_title || (variant && (variant.public_title || variant.name || variant.title)) || ''),
      item_category: String(lineItem?.product_type || (metaProduct && metaProduct.type) || 'product'),
      price: centsToAmount(lineItem?.price || (variant && variant.price)),
      product_handle: productHandle,
      product_id: String(lineItem?.product_id || dataProductId || (metaProduct && metaProduct.id) || ''),
      variant_id: normalizedVariantId
    };
  }

  function buildItem(item, quantity) {
    return {
      item_id: item.item_id,
      item_name: item.item_name,
      item_brand: item.item_brand,
      item_variant: item.item_variant,
      item_category: item.item_category,
      price: item.price || undefined,
      quantity: quantity
    };
  }

  function buildProductPayload(item, quantity, extra) {
    var value = item.price ? item.price * quantity : undefined;
    return Object.assign(
      {
        currency: getCurrency(),
        value: value,
        product_handle: item.product_handle,
        product_id: item.product_id,
        variant_id: item.variant_id,
        items: [buildItem(item, quantity)]
      },
      extra || {}
    );
  }

  function buildCartPayload(cart, extra) {
    var items = Array.isArray(cart?.items)
      ? cart.items.map(function (line) {
          return buildItem(getProductMeta(null, line.variant_id || line.id, line), line.quantity || 1);
        })
      : [];

    return Object.assign(
      {
        currency: getCurrency(),
        value: centsToAmount(cart?.total_price),
        cart_item_count: cart?.item_count || 0,
        cart_token: cart?.token || undefined,
        items: items
      },
      extra || {}
    );
  }

  function fetchCart() {
    var rootUrl = window.routes?.root_url || '/';
    var cartUrl = rootUrl.replace(/\/?$/, '/') + 'cart.js';
    return fetch(cartUrl, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (cart) lastCart = cart;
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  function trackAddToCartClick(form, target, source) {
    var sourceArea = getSourceArea(target, form);
    var variantId = getFormDataValue(form, 'id');
    var quantity = getQuantity(form);
    var item = getProductMeta(form, variantId);
    var disabled = target?.matches?.('[disabled], [aria-disabled="true"]') || target?.closest?.('[disabled], [aria-disabled="true"]');

    if (!form || !/\/cart\/add/.test(form.action || '')) {
      sendGtag('add_to_cart_error', {
        error_reason: 'missing_cart_add_form',
        source_area: sourceArea,
        submit_source: source || 'unknown'
      });
      return;
    }

    if (disabled) {
      var disabledKey = 'atc-disabled:' + variantId + ':' + sourceArea;
      if (dedupe(disabledKey, 1500)) return;
      sendGtag(
        'add_to_cart_error',
        buildProductPayload(item, quantity, {
          error_reason: 'disabled_button',
          source_area: sourceArea,
          submit_source: source || 'unknown'
        })
      );
      return;
    }

    if (!variantId) {
      sendGtag(
        'add_to_cart_error',
        buildProductPayload(item, quantity, {
          error_reason: 'missing_variant_id',
          source_area: sourceArea,
          submit_source: source || 'unknown'
        })
      );
      return;
    }

    var key = 'atc-click:' + variantId + ':' + quantity + ':' + sourceArea;
    if (dedupe(key, 1500)) return;

    sendGtag(
      'add_to_cart_click',
      buildProductPayload(item, quantity, {
        source_area: sourceArea,
        submit_source: source || 'unknown'
      })
    );
  }

  function trackAddToCartSuccess(detail) {
    var form = detail?.form || null;
    var response = detail?.response || null;
    var variantId = detail?.variantId || response?.variant_id || response?.id || getFormDataValue(form, 'id');
    var quantity = Number(detail?.quantity || response?.quantity || getQuantity(form));
    var item = getProductMeta(form, variantId, response);
    var sourceArea = detail?.sourceArea || getSourceArea(null, form);
    var key = 'atc-success:' + variantId + ':' + quantity + ':' + sourceArea;
    if (dedupe(key, 4000)) return;

    var payload = buildProductPayload(item, quantity, {
      source_area: sourceArea,
      cart_line_key: response?.key,
      cart_action_source: detail?.source || 'cart_add'
    });

    sendGtag('add_to_cart_success', payload);
    sendGtag('add_to_cart', payload);
    fetchCart();
  }

  function trackAddToCartError(detail) {
    var form = detail?.form || null;
    var response = detail?.response || null;
    var variantId = detail?.variantId || response?.variant_id || response?.id || getFormDataValue(form, 'id');
    var quantity = Number(detail?.quantity || getQuantity(form));
    var item = getProductMeta(form, variantId, response);
    var sourceArea = detail?.sourceArea || getSourceArea(null, form);
    var reason = detail?.reason || response?.message || response?.description || 'cart_add_error';
    var key = 'atc-error:' + variantId + ':' + reason + ':' + sourceArea;
    if (dedupe(key, 1500)) return;

    sendGtag(
      'add_to_cart_error',
      buildProductPayload(item, quantity, {
        source_area: sourceArea,
        error_reason: String(reason),
        error_message: String(detail?.message || response?.description || response?.message || '')
      })
    );
  }

  function trackCartDrawerOpen(detail) {
    fetchCart().then(function (cart) {
      if (!cart || !cart.item_count) return;
      var key = 'cart-drawer-open:' + (cart.token || cart.item_count + ':' + cart.total_price);
      if (dedupe(key, 5000)) return;
      var payload = buildCartPayload(cart, {
        source_area: getSourceArea(detail?.triggeredBy || null, null)
      });
      sendGtag('cart_drawer_open', payload);
      sendGtag('view_cart', payload);
    });
  }

  function trackCheckoutHandoff(detail) {
    var sourceArea = detail?.sourceArea || getSourceArea(detail?.target || null, null);
    var response = detail?.response || null;

    if (response && (response.variant_id || response.id)) {
      var variantId = detail?.variantId || response.variant_id || response.id;
      var quantity = Number(detail?.quantity || response.quantity || 1);
      var item = getProductMeta(detail?.form || null, variantId, response);
      var productPayload = buildProductPayload(item, quantity, {
        source_area: sourceArea,
        handoff_source: detail?.source || 'buy_now'
      });
      var productKey = 'checkout-handoff-product:' + variantId + ':' + sourceArea;
      if (!dedupe(productKey, 5000)) {
        sendGtag('checkout_handoff', productPayload);
        sendGtag('begin_checkout', productPayload);
      }
      return;
    }

    var cart = lastCart;
    if (!cart || !cart.item_count) {
      fetchCart().then(function (freshCart) {
        if (freshCart && freshCart.item_count) trackCheckoutHandoff(Object.assign({}, detail, { cart: freshCart }));
      });
      return;
    }

    var key = 'checkout-handoff-cart:' + (cart.token || cart.item_count + ':' + cart.total_price) + ':' + sourceArea;
    if (dedupe(key, 5000)) return;
    var payload = buildCartPayload(cart, {
      source_area: sourceArea,
      handoff_source: detail?.source || 'cart_checkout'
    });
    sendGtag('checkout_handoff', payload);
    sendGtag('begin_checkout', payload);
  }

  function trackVariantSelectFromPending(variant) {
    if (!pendingVariantSelection) return;
    var pending = pendingVariantSelection;
    pendingVariantSelection = null;
    var variantId = variant?.id || '';
    var key = 'variant-select:' + pending.optionName + ':' + pending.optionValue + ':' + variantId;
    if (dedupe(key, 1000)) return;

    sendGtag('variant_select', {
      product_handle: productHandleFromUrl(),
      variant_id: String(variantId),
      option_name: pending.optionName,
      option_value: pending.optionValue,
      selected_options: Array.isArray(variant?.options) ? variant.options.join(' / ') : undefined,
      variant_available: variant?.available,
      price: centsToAmount(variant?.price),
      source_area: pending.sourceArea
    });
  }

  function primeCartWhenRelevant() {
    if (
      document.querySelector('cart-drawer, cart-items-component, .cart__checkout-button, [name="checkout"]') ||
      document.body.classList.contains('template-cart')
    ) {
      fetchCart();
    }
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      var eventTarget = event.target instanceof Element ? event.target : event.target?.parentElement;
      var target = eventTarget?.closest('button, a, input[type="submit"]');
      if (!target) return;
      var label = (target.textContent || target.value || target.getAttribute('aria-label') || '').trim();
      if (/add\s*to\s*cart/i.test(label) || target.classList.contains('add-to-cart-button')) {
        var form = getFormForTarget(target);
        if (!form || !/\/cart\/add/.test(form.action || '')) return;
        trackAddToCartClick(form, target, 'pointerdown');
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !/\/cart\/add/.test(form.action || '')) return;
      trackAddToCartClick(form, event.submitter || form.querySelector('[type="submit"]'), 'submit');
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var eventTarget = event.target instanceof Element ? event.target : event.target?.parentElement;
      var target = eventTarget?.closest('button, a, input[type="submit"]');
      if (!target) return;

      var label = (target.textContent || target.value || target.getAttribute('aria-label') || '').trim();
      var href = target.getAttribute('href') || '';
      var name = target.getAttribute('name') || '';

      if ((/checkout/i.test(label) || name === 'checkout' || /\/checkout/.test(href)) && !target.matches('[disabled], [aria-disabled="true"]')) {
        trackCheckoutHandoff({
          target: target,
          source: 'checkout_click',
          sourceArea: getSourceArea(target, null)
        });
      }

      var productLink = target.closest('a[href*="/products/"]');
      if (productLink && !document.body.classList.contains('template-product')) {
        var productUrl = productLink.getAttribute('href') || '';
        var handle = productHandleFromUrl(productUrl);
        var title = productLink.getAttribute('aria-label') || productLink.textContent || handle;
        var key = 'select-item:' + handle;
        if (handle && !dedupe(key, 1500)) {
          sendGtag('select_item', {
            item_list_name: getSourceArea(productLink, null),
            product_handle: handle,
            items: [
              {
                item_id: handle,
                item_name: String(title || '').trim(),
                item_brand: 'Evolova',
                item_category: 'product'
              }
            ]
          });
        }
      }
    },
    true
  );

  document.addEventListener('evolova:cart-add-click', function (event) {
    trackAddToCartClick(event.detail?.form || null, event.detail?.target || null, event.detail?.sourceArea || event.detail?.source || 'product_form');
  });

  document.addEventListener('evolova:cart-add-success', function (event) {
    trackAddToCartSuccess(event.detail || {});
  });

  document.addEventListener('evolova:cart-add-error', function (event) {
    trackAddToCartError(event.detail || {});
  });

  document.addEventListener('evolova:checkout-handoff', function (event) {
    trackCheckoutHandoff(event.detail || {});
  });

  document.addEventListener('evolova:cart-drawer-open', function (event) {
    trackCartDrawerOpen(event.detail || {});
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event?.cartData) return;
      trackAddToCartSuccess({
        response: event.cartData,
        variantId: event.productVariantId,
        source: event.source || 'cart_update',
        sourceArea: event.sourceArea || 'product_form'
      });
    });

    subscribe(PUB_SUB_EVENTS.cartError, function (event) {
      trackAddToCartError({
        variantId: event?.productVariantId,
        response: event,
        reason: event?.message || event?.errors || 'cart_error',
        sourceArea: event?.sourceArea || 'product_form'
      });
    });

    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (event) {
      var target = event?.data?.target;
      if (!target) return;
      var optionName =
        target.name ||
        target.closest?.('fieldset')?.querySelector('legend')?.textContent ||
        target.closest?.('.product-form__input')?.querySelector('.form__label')?.textContent ||
        'option';
      pendingVariantSelection = {
        optionName: String(optionName).trim(),
        optionValue: String(target.value || '').trim(),
        sourceArea: getSourceArea(target, null),
        time: Date.now()
      };

      window.setTimeout(function () {
        if (!pendingVariantSelection || Date.now() - pendingVariantSelection.time > 1500) return;
        var pending = pendingVariantSelection;
        pendingVariantSelection = null;
        var form = target.closest('product-info')?.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
        sendGtag('variant_select', {
          product_handle: productHandleFromUrl(),
          variant_id: String(getFormDataValue(form, 'id') || ''),
          option_name: pending.optionName,
          option_value: pending.optionValue,
          source_area: pending.sourceArea
        });
      }, 1200);
    });

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      trackVariantSelectFromPending(event?.data?.variant);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', primeCartWhenRelevant, { once: true });
  } else {
    primeCartWhenRelevant();
  }
})();
